'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Validation$package$LatLon$1(lat, lon) {
  this.ml = 0.0;
  this.mm = 0.0;
  this.ml = lat;
  this.mm = lon;
}
export { $c_Lsamples_Validation$package$LatLon$1 as $c_Lsamples_Validation$package$LatLon$1 };
$p = $c_Lsamples_Validation$package$LatLon$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Validation$package$LatLon$1;
/** @constructor */
function $h_Lsamples_Validation$package$LatLon$1() {
}
export { $h_Lsamples_Validation$package$LatLon$1 as $h_Lsamples_Validation$package$LatLon$1 };
$h_Lsamples_Validation$package$LatLon$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (-2026037940));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().qW(this.ml));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().qW(this.mm));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 2);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsamples_Validation$package$LatLon$1) && ((this.ml === x$0.ml) && (this.mm === x$0.mm))));
});
$p.n = (function() {
  return 2;
});
$p.o = (function() {
  return "LatLon";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.ml;
  }
  if ((n === 1)) {
    return this.mm;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
$p.b = (function() {
  return ((this.ml + ",") + this.mm);
});
function $isArrayOf_Lsamples_Validation$package$LatLon$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ev)));
}
export { $isArrayOf_Lsamples_Validation$package$LatLon$1 as $isArrayOf_Lsamples_Validation$package$LatLon$1 };
var $d_Lsamples_Validation$package$LatLon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Validation$package$LatLon$1, "samples.Validation$package$LatLon$1", ({
  ev: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_Validation$package$LatLon$1 as $d_Lsamples_Validation$package$LatLon$1 };
